var map = {
	"./alastair-illustration.jpeg": 48,
	"./alastair-main.png": 49,
	"./coingossip-details.png": 50,
	"./coingossip-historical.png": 51,
	"./coingossip-main.png": 52,
	"./coingossip-popularity.png": 53,
	"./faveats-main.png": 54,
	"./faveats-map-selector.png": 55,
	"./logo-kpmgdv.png": 13,
	"./logo-ncs.svg": 14,
	"./logo-ufinity.png": 12,
	"./nowinsg-desktop.png": 56,
	"./nowinsg-mobile.png": 57,
	"./nowinsg-portrait.png": 58,
	"./profilepic-jin.2023.jpg": 59,
	"./profilepic-jin.jpg": 15,
	"./smartmirror-hardware.jpeg": 60,
	"./smartmirror-main.png": 61,
	"./theresistance-cards.jpg": 62,
	"./theresistance-main.png": 63,
	"./thumb-alastair.png": 16,
	"./thumb-coingossip.png": 17,
	"./thumb-faveats.png": 18,
	"./thumb-nowinsg.png": 19,
	"./thumb-smartmirror.png": 20,
	"./thumb-theresistance.png": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;